import { render } from "./index.vue?vue&type=template&id=43aa1c44&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=43aa1c44&scoped=true&lang=css"

import exportComponent from "D:\\myProject\\qtx\\2026\\qtx-officialwebsite\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43aa1c44"]])

export default __exports__